import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';

export default {
  apollo: {
    contratoReportesFisicos: {
      query: CONTRATO_REPORTES_FISICOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    mixAvanceFisicoFecha(fecha = new Date()) {
      const lista = this.getContratoReportesFisicos
        .filter((item) => this.$moment(item.fecha).isSameOrBefore(fecha))
        .sort((a, b) => new Date(`${b.fecha} 00:00:00`) - new Date(`${a.fecha} 00:00:00`))
        .map((item) => item.avanceFisico);
      const [ultimo] = lista;
      return ultimo || 0;
    },
    mixAvanceFisicoRango(fechaInicio, fechaTermino = new Date()) {
      return this.getContratoReportesFisicos
        .filter((item) => this.$moment(item.fecha).isBetween(fechaInicio, fechaTermino, undefined, '[]'))
        .sort((a, b) => new Date(`${a.fecha} 00:00:00`) - new Date(`${b.fecha} 00:00:00`))
        .map((item) => ({
          fecha: item.fecha,
          avanceFisico: item.avanceFisico,
        }));
    },
  },
  computed: {
    getContratoReportesFisicos() {
      if (!this.contratoReportesFisicos) return [];
      return this.contratoReportesFisicos;
    },
    mixGetAvanceFisico() {
      if (!this.contratoReportesFisicos) return [];
      return this.contratoReportesFisicos
        .sort((a, b) => new Date(`${a.fecha} 00:00:0`) - new Date(`${b.fecha} 00:00:0`))
        .map(({ fecha, avanceFisico }) => ({
          fecha,
          avance: avanceFisico,
        }));
    },
  },
};
